import React from "react";
import { Link } from "react-router-dom";
import { Row, Col, Form, Input, Button, message } from "antd";
import axios from "axios";

import LeftContent from "../leftContent";

export default function ResetPassword() {
  const urlParams = new URLSearchParams(window.location.search);
  const uid = urlParams.get("uid");
  const token = urlParams.get("token");
  const user = urlParams.get("user");

  console.log(uid, token, user)
  const handleResetPassword = async (values) => {
    const { password, password2 } = values;

    if (password !== password2) {
      message.error("Passwords do not match");
      return;
    }

    const postData = {
      password,
      password2,
      uid,
      token,
      user
    };

    try {
      const response = await axios.put(
        `https://internal.orevan-prox.com/password_reset_confirm/${uid}/${token}/${user}`,
        postData
      );

      if (response.status === 200) {
        message.success("Password reset successful");
      } else {
        message.error("Failed to reset password");
      }
    } catch (error) {
      console.error("Password reset error:", error);
      message.error("Failed to reset password");
    }
  };

  return (
    <Row gutter={[32, 0]} className="hp-authentication-page">
      <LeftContent />

      <Col md={12}>
        <Row className="hp-h-100" align="middle" justify="center">
          <Col
            xxl={11}
            xl={15}
            lg={20}
            md={20}
            sm={24}
            className="hp-px-sm-8 hp-pt-24 hp-pb-48"
          >
            <h1>Reset Password</h1>
            <p className="hp-mt-8 hp-text-color-black-60">
              Email verification is done. Please choose another password
            </p>

            <Form
              layout="vertical"
              name="basic"
              className="hp-mt-sm-16 hp-mt-32"
              onFinish={handleResetPassword}
            >
              <Form.Item
                label="Password :"
                name="password"
                rules={[
                  { required: true, message: "Please enter your password" },
                  { min: 6, message: "Password must be at least 6 characters" },
                ]}
              >
                <Input.Password placeholder="At least 6 characters" />
              </Form.Item>

              <Form.Item
                label="Confirm Password :"
                name="password2"
                rules={[
                  { required: true, message: "Please confirm your password" },
                  { min: 6, message: "Password must be at least 6 characters" },
                ]}
              >
                <Input.Password placeholder="At least 6 characters" />
              </Form.Item>

              <Form.Item className="hp-mt-16 hp-mb-8">
                <Button block type="primary" htmlType="submit">
                  Reset Password
                </Button>
              </Form.Item>
            </Form>

            <div className="hp-form-info">
              <span className="hp-text-color-black-80 hp-text-color-dark-40 hp-caption hp-mr-4">
                Go back to
              </span>

              <Link
                to="/"
                className="hp-text-color-primary-1 hp-text-color-dark-primary-2 hp-caption"
              >
                Login
              </Link>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
